<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.institutions', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card-title">
                    <router-link :to="{ name: 'add-institution' }" v-if="can || hasAssistante">
                        {{ $t('message.add') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>

                <template v-if="rows">

                    <vue-good-table
                            id="operation"
                            v-if="mInstitutions.length >0"
                            :columns="institutionsColumns"
                            :rows="mInstitutions"
                            :search-options="enabled"
                            :pagination-options="paginationOptions"
                            @on-row-click="onInstitutionRowClick"
                    />
                </template>

                <template v-else>
                    <div class="card">
                        <div class="card-body text-xs-center">
                            <p class="card-text">
                                {{ $t('message.noResults') }}
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        name: "Institutions",

        computed: {
            ...mapGetters(["institutions",'hasAdminRole',
                'hasGestionnaireRole','hasAssistante']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },

            mInstitutions: function() {
                let iArray = [];

                _.forEach(_.orderBy(this.institutions,['created_at'],['desc']), function(institution) {
                    let i = {};

                    i.nom = institution.name;
                    i.description = (!_.isNull(institution.description)? institution.description.length > 20 : false) ? institution.description.substr(0, 20) + '...' : institution.description;
                    i.date = moment(institution.created_at).format('DD-MM-YYYY');
                    i.id = institution.id;
                    i.slug = institution.slug;

                    iArray.push(i);
                });

                return iArray;
            },

            rows: function() {
                return this.mInstitutions.length;
            }
        },

        data() {
            return {
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },

                enabled: {enabled: true},

                sort: {
                    enabled: true,
                    initialSortBy: {field: 'date', type: 'desc'}
                },

                institutionsColumns: [
                    {
                        field: 'nom',
                        label: this.$i18n.t('message.name'),
                    },
                    {
                        field: 'description',
                        label: this.$i18n.t('message.description')
                    },
                    {
                        field: 'date',
                        label: this.$i18n.t('message.createdAt'),
                        sortable: true
                    },
                ],
                offset: 0,
                limit: -1,
            }
        },

        methods: {
            getInstitutions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getInstitutions', { args : args });
            },

            onInstitutionRowClick(params){
                this.$router.push({ name: 'institution', params: { institution: params.row.slug } });
            },

            deleteInstitution(institution) {
                let self = this;

                let args = {
                    institution: institution
                };

                let successMessage = this.$i18n.t('message.institutionDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteInstitution', { args, index: institution, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + institution);
                    });
            }
        },

        mounted() {
            // Fetch institution list
            this.getInstitutions();
        }
    }
</script>

<style scoped>

</style>